import { get } from "@insite/client-framework/Services/ApiService";
import { GetBrandsApiParameter } from "@insite/client-framework/Services/BrandService";
import { BrandCollectionModel } from "@insite/client-framework/Types/ApiModels";

const brandsUrl = "/api/v1/poolcorp/brands";

export function getBrands(parameter: GetBrandsApiParameter) {
    return get<BrandCollectionModel>(`${brandsUrl}/`, parameter);
}
